import { NotificationBanner as NotificationBannerComponent } from '@almbrand/notificationbanner';
import { PageContext } from 'context/PageContext';
import { useContext, useState } from 'react';

export const NotificationBanner: React.FC<NotificationReference> = ({ richText, backgroundColor, contentId }) => {
	const sessionKey = `close-notification-banner-${contentId}`;
	const pageContext = useContext(PageContext);
	const theme = pageContext.theme;

	const [displayBanner, setDisplayBanner] = useState(!sessionStorage.getItem(sessionKey));

	const onBannerClose = () => {
		sessionStorage.setItem(sessionKey, 'true');
		setDisplayBanner(false);
	};

	return (
		displayBanner && (
			<NotificationBannerComponent
				content={richText}
				themeName={theme}
				backgroundColor={
					backgroundColor?.cssClass.includes('bg-navy') ? 'bg-notification' : backgroundColor?.cssClass
				}
				onClose={onBannerClose}
			/>
		)
	);
};
